export class odMenu extends DrupalBehavior {
  onContent(context) {
    const odMobileMenu = $('.od-menu.mobile', context);
    /* istanbul ignore else - this is always true */
    if (odMobileMenu) {
      $('.od-menu.mobile button', context).on('click', function (e) {
        $(this).toggleClass('open');
        const menu = $('.od-menu.mobile>ul');
        if ($(this).hasClass('open')) {
          gsap.to(menu, { duration: 0.5, ease: 'power4.out', height: 'auto' });
        } else {
          gsap.to(menu, { duration: 0.5, ease: 'power4.out', height: 0 });
        }
      });

      $('.od-menu.mobile .expandable span', context).on('click', function (e) {
        $(this).toggleClass('open');
        const menu = $('.expandable ul');
        if ($(this).hasClass('open')) {
          gsap.to(menu, { duration: 0.5, ease: 'power4.out', height: 'auto' });
        } else {
          gsap.to(menu, { duration: 0.5, ease: 'power4.out', height: 0 });
        }
      });
    }

    const odDesktopMenu = $('.od-menu.desktop', context);
    /* istanbul ignore else - this is always true */
    if (odDesktopMenu) {
      $('.od-menu.desktop .expandable', context).hover(
        function () {
          const toggle = $(this).find('span');
          const menu = $(this).find('ul');
          menu.slideDown('fast');
          toggle.addClass('open');
        },
        function () {
          const toggle = $(this).find('span');
          const menu = $(this).find('ul');
          menu.slideUp('fast');
          toggle.removeClass('open');
        }
      );
    }
  }
}

DrupalBehavior.register('rush_theme.components', 'od_menu', odMenu);
